<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="14" height="14" rx="7" fill="currentColor" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.04218 11.447H14.9578V12.847H9.04218V11.447Z" />
</svg>
